import React, { Component, Fragment } from 'react';

import { graphql, createRefetchContainer } from 'react-relay';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import clsx from 'clsx';

import { withStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';
import { CustomSnackbar } from '../index.js';

import frontSquareBoxEventDataSubscription from '../../data/subscription/frontSquareBoxEventDataSubscription';
import selectFrontSquareBoxByGuestFront from '../../data/mutations/front/selectFrontSquareBoxByGuestFront';
import removeSelectedFrontSquareBoxByGuest from '../../data/mutations/front/removeSelectedFrontSquareBoxByGuest';
import randomizeFrontSquareBoxByGuest from '../../data/mutations/front/randomizeFrontSquareBoxByGuest';
import { BackgroundImg } from '../../components';
import { useStyles } from './styles.js';
class GuestSquareBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      board: Array(10).fill(0),
      guest_data:
        this.props.getFrontGuestSquareBoardData &&
        this.props.getFrontGuestSquareBoardData.getFrontGuestSquareBoardData &&
        this.props.getFrontGuestSquareBoardData.getFrontGuestSquareBoardData
          .data,
      squares: {},
      deleteSelected: null,
      openSnackbar: '',
      snackbarMessageType: '',
      snackbarMessage: '',
      isSubmitted: false,
      openDescriptionPopover: false,
      count: 0,
    };
    this.handleSucessfulResponse = this.handleSucessfulResponse.bind(this);
    this.handleFailedResponse = this.handleFailedResponse.bind(this);
  }

  componentDidMount() {
    let count = 0;
    if (this.state.guest_data) {
      let squares = {};
      this.state.guest_data.responses.map(response => {
        squares[response.square] = {
          guest_id: response.guest_id,
          _id: response._id,
        };
        // Count how many squares were chosen by this guest
        if(response.guest_id == this.state.guest_data._id) count += 1;
      });
      this.setState({ squares, count });
    }

    if (this.props.event) {
      frontSquareBoxEventDataSubscription(
        {
          event_id: this.props.event._id,
          current_board_id: this.props.currentQuestionId,
        },
        response => {
          this._refetch();
        },
        error => console.log('error'),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.getFrontGuestSquareBoardData &&
      nextProps.getFrontGuestSquareBoardData.getFrontGuestSquareBoardData &&
      nextProps.getFrontGuestSquareBoardData.getFrontGuestSquareBoardData.data
    ) {
      let guest_data =
        nextProps.getFrontGuestSquareBoardData.getFrontGuestSquareBoardData
          .data;
      let squares = {};
      guest_data.responses.map(response => {
        squares[response.square] = {
          guest_id: response.guest_id,
          _id: response._id,
        };
      });

      this.setState({ guest_data, squares });
    }
  }

  onRandomizeClick = () => {
    this.setState({ isSubmitted: true, count: this.state.guest_data.allowed_squares });
    let values = {
      guest_id: this.state.guest_data._id,
      event_id: this.props.event._id,
      question_id: this.props.currentQuestionId,
    };
    randomizeFrontSquareBoxByGuest(values, response => {
      if (response.randomizeFrontSquareBoxByGuest.code == 200) {
        this.handleSucessfulResponse(
          response.randomizeFrontSquareBoxByGuest.message,
        );
      } else {
        this.handleFailedResponse(
          response.randomizeFrontSquareBoxByGuest.message,
        );
      }
    });
  };

  handleBoxClick(row, col) {
    const self = this;
    let current = this.state.count;
    this.setState({ isSubmitted: true, count: current + 1 });
    let values = {
      guest_id: parseInt(this.state.guest_data._id),
      answer_col: parseInt(col),
      answer_row: parseInt(row),
      event_id: parseInt(this.props.event._id),
      question_id: parseInt(this.props.currentQuestionId),
      assigned_by_admin: false,
    };
    selectFrontSquareBoxByGuestFront(values, response => {
      if (response.selectFrontSquareBoxByGuest.code == 200) {
        this.handleSucessfulResponse(
          response.selectFrontSquareBoxByGuest.message,
        );
      } else {
        this.handleFailedResponse(response.selectFrontSquareBoxByGuest.message);
      }
    });
  }

  handleSquareBoxRemoveClick(_id, box) {
    let current = this.state.count;
    this.setState({ isSubmitted: true, deleteSelected: box, count: current - 1 });
    removeSelectedFrontSquareBoxByGuest({ game1_answer_id: _id }, response => {
      if (response.removeSelectedFrontSquareBoxByGuest.code == 200) {
        this.handleSucessfulResponse(
          response.removeSelectedFrontSquareBoxByGuest.message,
        );
      } else {
        this.handleFailedResponse(
          response.removeSelectedFrontSquareBoxByGuest.message,
        );
      }
    });
  }

  handleSucessfulResponse(message) {
    this.setState({
      isSubmitted: false,
      openSnackbar: true,
      snackbarMessageType: 'Success',
      snackbarMessage: message,
      deleteSelected: '',
    });
  }

  handleFailedResponse(message) {
    this.setState({
      isSubmitted: false,
      openSnackbar: true,
      snackbarMessageType: 'Error',
      snackbarMessage: message,
      deleteSelected: '',
    });
  }

  _refetch = () => {
    this.props.relay.refetch(
      {
        event_token: this.props.event.game_link,
        guest_token: this.props.guest_token,
        game_id: this.props.game_id,
        question_id: this.props.currentQuestionId,
      },
      null, // We can use the refetchVariables as renderVariables
      () => {},
      { force: true },
    );
  };

  render() {
    const { classes } = this.props;
    let available_squares =
      this.state.guest_data.allowed_squares -
      this.state.count;
    const page_bg_image = this.props.event.page_bg_image;
    const show_page_bg_image = this.props.event.show_page_bg_image;

    const uhg = this.props.event.client && this.props.event.client.client_name.includes('UHG');
    const uhg_logo_url = 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjesAJXzZJG31wU3gpGggz5aABis_9hgIqUVGieR5BhJdTNjRlSE55udtk48BLdmBbAtiXtoB7L8bJ7yjOGzg8RLw5lR7WgszTZl3mLWmQsgEsv27c82kJ18nG5UolcUgWpa5Lko0mctqdV-oUN9FSCwWeaYLTWEdnaujtO_y8LHaOVgWBStEusObXDMgs/s1549/UHG_black.png';

    return (
      <Grid className={classes.squaresRoot}>
        <Grid
          container
          className={classes.titleRandomize}
          spacing={3}
          style={{ width: '100%', margin: 'auto' }}
        >
          <BackgroundImg page_bg_image={page_bg_image} show={show_page_bg_image} />
          {/* Dialog for game description open for small screen sizes */}

          <Dialog
            maxWidth="md"
            fullWidth={true}
            className={classes.dialog}
            onClose={() => {
              this.setState({ openDescriptionPopover: false });
            }}
            open={this.state.openDescriptionPopover}
          >
            <div className={classes.dialogTitle}>
              <h2>{'How to play'}</h2>
              <CloseIcon
                onClick={() => {
                  this.setState({ openDescriptionPopover: false });
                }}
              />
            </div>
            <DialogContent dividers style={{ textAlign: 'center' }}>
              <DialogContentText>
                <h4
                  className={classes.dialogDecription}
                  // style={{ color: this.props.textColor }}
                >
                  {this.props.game && Parser(this.props.game.description)}
                </h4>
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <Grid container spacing={3} style={{ width: '90%', margin: 'auto' }}>
            <Grid item xs={12} className={classes.welcome}>
            {
              uhg ?
              <Grid style={{marginTop: '2em'}}>
                <span className={classes.titleText}>
                  Welcome, {this.state.guest_data && this.state.guest_data.guest_name}
                </span>
                <img src={uhg_logo_url} className={classes.shortLogo} />
              </Grid>
              :
              <Grid container className={classes.welcomeGrid}>
                <h1>Welcome</h1>
                <HelpOutlineIcon
                  onClick={() => {
                    this.setState({ openDescriptionPopover: true });
                  }}
                  className={classes.help}
                  style={{ color: this.props.buttonTextColor }}
                />
              </Grid>
            }
            { !uhg &&
              <h2 style={{ color: this.props.textColor }}>
                {this.state.guest_data && this.state.guest_data.guest_name}
              </h2>
            }
              <h4
                className={classes.description}
                style={ uhg ? { color: this.props.textColor, marginTop: '1em' } : { color: this.props.textColor }}
              >
                {this.props.game && Parser(this.props.game.description)}
              </h4>
            </Grid>

            <Grid container className={classes.randomizeSelectionGroup}>
              {available_squares <= 0 ? (
                <h3>You are all set!</h3>
              ) : (
                <h3>Please select {available_squares} square(s)</h3>
              )}
              <Button
                id="continue-button"
                className={clsx(classes.submitButton, classes.borderButton)}
                color="secondary"
                size="large"
                type="button"
                variant="contained"
                disabled={this.state.isSubmitted}
                onClick={this.onRandomizeClick}
                onMouseOver={e => {
                  this.props.onMouseOver(e);
                }}
                onMouseOut={e => {
                  this.props.onMouseOut(e);
                }}
                style={{
                  color: this.props.buttonTextColor,
                  borderColor: this.props.buttonTextColor,
                  background: this.props.buttonBgColor,
                  marginTop: '10px',
                }}
              >
                Randomize
              </Button>
            </Grid>

            {this.props.buttonsContainer}

            <CustomSnackbar
              onClose={() => {
                this.setState({ openSnackbar: false });
              }}
              open={this.state.openSnackbar}
              type={this.state.snackbarMessageType}
              message={this.state.snackbarMessage}
              successCSS={
                this.state.snackbarMessageType != 'Error'
                  ? { background: this.props.buttonTextColor }
                  : null
              }
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item lg={12} md={12} xs={12} sm={12}>
            <div className={classes.tableScrollable}>
              <div
                className={clsx(classes.squareBoxXAxisLabel)}
                // style={{ color: textColor }}
              >
                <span>Home Team ({this.props.event.team1.team_name}) </span>
              </div>
              <Table
                style={{
                  minWidth: '200px',
                  width: '90%',
                  margin: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  border: '0.5px solid',
                  borderColor: this.props.buttonTextColor,
                }}
              >
                <TableBody className={classes.squaresContainer}>
                  {this.state.board.map((key, i) => {
                    return (
                      <TableRow
                        id={key + '_sqBoardRow'}
                        key={key + '_sqBoardRow'}
                        className={classes.squaresRow}
                      >
                        {this.state.board.map((innerKey, j) => {
                          let selected = this.state.squares[`${i}` + `${j}`];
                          //This is rendered when box is selected
                          if (selected) {
                            //This block gets called when Selected block is of current guest
                            if (
                              selected.guest_id == this.state.guest_data._id
                            ) {
                              let deleteSelected =
                                this.state.deleteSelected &&
                                this.state.deleteSelected == `${i}` + `${j}`;
                              if (deleteSelected) {
                                return (
                                  <TableCell
                                    id={innerKey + '_sqBoardCol'}
                                    key={innerKey + '_sqBoardCol'}
                                    disabled={this.state.isSubmitted}
                                    onClick={this.handleSquareBoxRemoveClick.bind(
                                      this,
                                      selected._id,
                                      `${i}` + `${j}`,
                                    )}
                                    className={clsx(
                                      classes.cell,
                                      classes.removeBox,
                                    )}
                                    style={{
                                      borderColor: this.props.buttonTextColor,
                                      backgroundColor: this.props
                                        .buttonTextColor,
                                    }}
                                  >
                                    <DeleteIcon
                                      fontSize="small"
                                      className={classes.actionIcon}
                                    />
                                  </TableCell>
                                );
                              } else {
                                return (
                                  <TableCell
                                    id={innerKey + '_sqBoardCol'}
                                    key={innerKey + '_sqBoardCol'}
                                    disabled={this.state.isSubmitted}
                                    onClick={() =>
                                      this.setState({
                                        deleteSelected: `${i}` + `${j}`,
                                      })
                                    }
                                    className={clsx(
                                      classes.cell,
                                      classes.removeBox,
                                    )}
                                    style={{
                                      borderColor: this.props.buttonTextColor,
                                      backgroundColor: this.props
                                        .buttonTextColor,
                                    }}
                                  ></TableCell>
                                );
                              }
                            } else {
                              // This is rendered when current box is not if current guest
                              // that's why blocked square css is applied
                              return (
                                <TableCell
                                  id={innerKey + '_sqBoardCol'}
                                  key={innerKey + '_sqBoardCol'}
                                  className={clsx(
                                    classes.cell,
                                    classes.notAllowedToClick,
                                  )}
                                  disabled={true}
                                  style={{
                                    borderColor: this.props.buttonTextColor,
                                    backgroundColor: `${this.props.buttonTextColor}3F`,
                                  }}
                                />
                              );
                            }
                          } else {
                            return (
                              <TableCell
                                id={innerKey + '_sqBoardCol'}
                                key={innerKey + '_sqBoardCol'}
                                disabled={this.state.isSubmitted}
                                onClick={this.handleBoxClick.bind(this, i, j)}
                                className={classes.cell}
                                style={{
                                  borderColor: this.props.buttonTextColor,
                                }}
                              />
                            );
                          }
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </Grid>
          <Grid container style={{ justifyContent: 'center' }}>
            <span>Away Team ({this.props.event.team2.team_name})</span>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

GuestSquareBoard.propTypes = {
  className: PropTypes.string,
};

export default createRefetchContainer(
  withStyles(useStyles)(GuestSquareBoard),
  {
    getFrontGuestSquareBoardData: graphql`
      fragment GuestSquareBoard_getFrontGuestSquareBoardData on Query
        @argumentDefinitions(
          event_token: { type: "String!" }
          guest_token: { type: "String!" }
          game_id: { type: "ID!" }
          question_id: { type: "ID!" }
        ) {
        getFrontGuestSquareBoardData(
          event_token: $event_token
          guest_token: $guest_token
          game_id: $game_id
          question_id: $question_id
        ) {
          code
          message
          data {
            _id
            guest_name
            allowed_squares
            number_of_selected_squares
            responses {
              _id
              square
              guest_id
            }
          }
        }
      }
    `,
  },
  graphql`
    query GuestSquareBoardefetchQuery(
      $event_token: String!
      $guest_token: String!
      $game_id: ID!
      $question_id: ID!
    ) {
      ...GuestSquareBoard_getFrontGuestSquareBoardData
        @arguments(
          event_token: $event_token
          guest_token: $guest_token
          game_id: $game_id
          question_id: $question_id
        )
    }
  `,
);
